function createPrintable(shortName, title, description, src, alt, displaySrc, displayAlt) {
    return {
        shortName: shortName,
        title: title,
        description: description,
        src: src,
        alt: alt,
        displaySrc: displaySrc,
        displayAlt: displayAlt
    };
}

export default createPrintable;